import React, { useEffect, useRef } from 'react';
import { Box } from '@chakra-ui/layout';
import mariopic from '../utils//images/mario/mario.png';
import { Image } from '@chakra-ui/react';
import { useMotionValue, motion } from 'framer-motion';

const MotionImg = motion(Image);

const Mario = () => {
  const scrollY = useRef();

  const marioRef = useRef();

  const marioPos = useRef();

  const x = useMotionValue(0);

  const rotate = useMotionValue(0);

  useEffect(() => {
    const handleScroll = () => {
      marioPos.current =
        marioRef.current.getBoundingClientRect().top + window.scrollY;
      scrollY.current = window.scrollY + window.innerHeight;
      x.set((scrollY.current - marioPos.current) * 0.3);
      rotate.set((scrollY.current - marioPos.current) * 1);
    };

    const handleResize = () => {
      marioPos.current =
        marioRef.current.getBoundingClientRect().top + window.scrollY;
      scrollY.current = window.scrollY + window.innerHeight;
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    scrollY.current = window.scrollY + window.innerHeight;
    marioPos.current =
      marioRef.current.getBoundingClientRect().top + window.scrollY;
    x.set((scrollY.current - marioPos.current) * 0.5);
    rotate.set((scrollY.current - marioPos.current) * 1);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [rotate, x]);

  return (
    <Box display="flex" justifyContent="center" mt={12} mb={12}>
      <MotionImg
        ref={marioRef}
        src={mariopic}
        width={{ base: '50', md: '75' }}
        height={{ base: '50', md: '75' }}
        objectFit="contain"
        position="relative"
        style={{ rotate }}
        transition="linear .2s"
      />
    </Box>
  );
};

export default Mario;
